<template>
    <div class="vipbox">
        <div class="covers"></div>
        <div class="vip_info">
            <img class="close" src="../../../static/close.png" alt="" @click="Close">
            <img class="vipimg" :src="'https://mktcdn.epermarket.com/Resource/public/share/vip' + getLang +'.jpg'" alt="" >
            <div class="clickBlock" :class="getLang == 1 ? '' : getLang == 2 ? 'en' : getLang == 3 ? 'fr' : ''" @click="toAbout"></div>
        </div>
    </div>
</template>
<script>
  export default {
    name: "Vipbox",
    data() {
      return {

      };
    },
    computed: {
        getLang(){
            return localStorage.getItem("lang");
        }
    },
    methods: {
        Close(){
            this.$emit("close");
        },
        toAbout(){
            const routeData = this.$router.resolve({ path: '/about', query: { isShowMenu:9, NotifyId:110 }})
            window.open(routeData.href, '_blank')
        }
    }
  }

</script>
<style lang="scss" scoped>
  @import "../../style/base.scss";
  @import "../../style/color.scss";
.vipbox{
    .covers{
        position: fixed;
        left: 0;
        top: 0;
        bottom: 0;
        right: 0;
        background-color: #000;
        opacity: 0.76;
        z-index: 2000;
    }
    .vip_info{
        position: fixed;
        top: 50%;
        left: 50%;
        width: 493px;
        height: 508px;
        z-index: 2001;
        transform: translate(-50%,-50%);
        border-radius: 40px;
        overflow: hidden;
        .vipimg{
            width: 100%;
            height: auto;
            display: block;
        }
        .close{
            width: 38px;
            height: 38px;
            display: block;
            position: absolute;
            right: 12px;
            top: 12px;
            z-index: 10;
            cursor:pointer;
        }
        .clickBlock{
            position: absolute;
            top: 77%;
            left: 0;
            width: 100%;
            height: 23px;
        }
        .clickBlock.en{
            top: 82%;
        }
        .clickBlock.fr{
            top: 83%;
        }
    }
}
</style>
  


// WEBPACK FOOTER //
// src/components/public/Vipbox.vue